<template>
  <div>
    <b-card
      title="Channel Currencies"
      class="mb-0"
    >
      <b-table
        class="position-relative"
        responsive
        :fields="tableFields"
        :items="currencyOptions"
        show-empty
        hover
        outlined
        selectable
        select-mode="single"
        sticky-header
        :borderless="false"
        empty-text="No matching records found"
        @row-selected="onRowSelected"
      />

      <b-button
        v-b-modal.modal-currency-add-new
        variant="success"
        class="float-right mr-2"
      >
        <feather-icon
          icon="PlusIcon"
        />
        Add New Currency
      </b-button>
      <b-button
        variant="danger"
        class="float-right mr-2"
        @click.prevent="deleteConfirm"
      >
        <feather-icon
          icon="Trash2Icon"
        />
        Delete
      </b-button>
    </b-card>

    <b-modal
      id="modal-currency-add-new"
      cancel-variant="outline-secondary"
      ok-title="Accept"
      cancel-title="Close"
      centered
      title="Add New Currency"
      @ok="addNew"
    >
      <b-form>
        <b-form-group>
          <label for="currency_code">Code</label>
          <b-form-input
            id="currency_code"
            v-model="currency.code"
            oninput="if(value.length > 3)value = value.slice(0, 3)"
          />
        </b-form-group>
        <b-form-group>
          <label for="currency_name">Name</label>
          <b-form-input
            id="currency_name"
            v-model="currency.name"
            oninput="if(value.length > 32)value = value.slice(0, 32)"
          />
        </b-form-group>
        <b-form-group>
          <label for="currency_symbol">Symbol</label>
          <b-form-input
            id="currency_symbol"
            v-model="currency.symbol"
            oninput="if(value.length > 8)value = value.slice(0, 8)"
          />
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BTable, BButton, BModal, VBModal, BForm, BFormInput, BFormGroup,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useChannelsJs from './channels'

const {
  saveChannelElement,
} = useChannelsJs()

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    currencyOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selected: [],
      currency: {
        code: '',
        name: '',
        symbol: '',
      },
      tableFields: [
        'code',
        'name',
        'symbol',
      ],
    }
  },
  methods: {
    onRowSelected(items) {
      this.selected = items
    },
    showAlert(icon, title, text) {
      this.$swal({
        icon,
        title,
        text,
        customClass: {
          confirmButton: `btn btn-${icon}`,
        },
      })
    },
    showToast(title, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title,
            icon: 'BellIcon',
            text,
            variant: 'warning',
          },
        },
        {
          position: 'top-center',
        },
      )
    },
    deleteConfirm() {
      if (this.selected < 1) {
        this.showToast('Warning', 'No Currency Selected.')
        return
      }
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.delete()
        }
      })
    },
    delete() {
      const currency = this.selected[0]
      const item = {
        index: 4,
        op: 'DELETE',
        data: currency,
      }
      saveChannelElement(
        item,
        () => {
          this.showAlert('success', 'Success!', `${currency.code} ${item.op} Done.`)
          this.$emit('updated')
        },
        fail => {
          this.showAlert('warning', 'Fail!', `${fail}`)
        },
      )
    },
    addNew() {
      const item = {
        index: 4,
        op: 'CREATE',
        data: this.currency,
      }
      saveChannelElement(
        item,
        () => {
          this.showAlert('success', 'Success!', `${this.currency.code} ${item.op} Done.`)
          this.$emit('updated')
        },
        fail => {
          this.showAlert('warning', 'Fail!', `${fail}`)
        },
      )
    },
  },
}
</script>
